import { render, staticRenderFns } from "./71.vue?vue&type=template&id=63d9669a&scoped=true&"
var script = {}
import style0 from "./71.vue?vue&type=style&index=0&id=63d9669a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d9669a",
  null
  
)

export default component.exports